import { CbhFeatureFlag } from "../../FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "../../FeatureFlags/useCbhFlag";

export function useIsHiringReferralEnabled() {
  const { type: activationType } = useCbhFlag(CbhFeatureFlag.WORKER_TO_WORKER_REFERRAL_TYPE, {
    defaultValue: { type: "FLEX_ACTIVATION" },
  });

  return activationType === "FLEX_ACTIVATION_OR_HIRING";
}
